module.exports = __webpack_public_path__ + "img/dna-house.26c20453.png";